import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MagnifyingGlass, Clock, User } from '@phosphor-icons/react';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const actionColor = (action) => {
  if (action.includes('delete')) return 'text-red-600';
  if (action.includes('create')) return 'text-emerald-600';
  if (action.includes('update')) return 'text-blue-600';
  if (action.includes('reset')) return 'text-orange-600';
  return 'text-muted-foreground';
};

export default function CmsActivity() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const params = { limit: 100 };
      if (q) params.q = q;
      const { data } = await axios.get(`${API}/api/admin/cms/activity`, { params, withCredentials: true });
      setItems(data.items);
      setTotal(data.total);
    } catch (e) { toast.error('Failed to load activity log'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [q]);

  return (
    <div data-testid="cms-activity">
      <div className="mb-4">
        <h2 className="text-2xl" style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 700 }}>Activity Log</h2>
        <p className="text-sm text-muted-foreground">{total} events</p>
      </div>

      <div className="relative mb-4 max-w-md">
        <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search action, target, or admin email…"
          data-testid="cms-activity-search"
          className="w-full pl-9 pr-3 py-2 text-sm bg-muted/40 border border-transparent focus:border-primary focus:bg-background rounded-lg outline-none"
        />
      </div>

      <div className="bg-card border border-border rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/40 text-xs uppercase tracking-wider text-muted-foreground">
            <tr>
              <th className="text-left px-4 py-3">Admin</th>
              <th className="text-left px-4 py-3">Action</th>
              <th className="text-left px-4 py-3">Target</th>
              <th className="text-left px-4 py-3">IP</th>
              <th className="text-left px-4 py-3">When</th>
            </tr>
          </thead>
          <tbody data-testid="cms-activity-tbody">
            {loading ? (
              <tr><td colSpan={5} className="text-center py-10 text-muted-foreground">Loading…</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={5} className="text-center py-10 text-muted-foreground">No activity recorded yet.</td></tr>
            ) : items.map((row) => (
              <tr key={row.id} className="border-t border-border hover:bg-muted/20">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <User size={14} className="text-muted-foreground" />
                    <div className="min-w-0">
                      <p className="text-xs font-medium truncate">{row.actor_name || 'Admin'}</p>
                      <p className="text-[10px] text-muted-foreground truncate">{row.actor_email}</p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-mono ${actionColor(row.action || '')}`}>{row.action}</span>
                </td>
                <td className="px-4 py-3 text-xs text-muted-foreground truncate max-w-[240px]">{row.target}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{row.ip || '—'}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">
                  <Clock size={12} className="inline mr-1" />
                  {new Date(row.created_at).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
